import StickyBottomBarMobile from "./StickyBottomBarMobile";

export default StickyBottomBarMobile;
